import React, { useEffect, useRef, useState } from "react";
import { ROUTES } from "../utils/Routes";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { bm_date, getBindingLabel, getRowClass, showConfirm } from "../utils/Utils";
import Input from "../ui/Input";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import InventoryOrders from "./InventoryOrders";
import { createModal } from "../hooks/createModal";
import InventoryOrder from "./InventoryOrder";
import Label from "../ui/Label";
import Space from "../ui/Space";
import NumberPicker from "./NumberPicker";
export default function InventoryReserve(props) {

    const { controller = "", primary_code = "", condition_code = "", onEdit = () => { }, updateSellPrice = () => { }, callback = () => { }, fetchExtra = () => { }, fullData = {}, setFullData = () => { }, sell_price, signal = {}, tab = "orders", togglePubstock = () => { }, state = {}, setState = () => { } } = props;
    const route = ROUTES.INVENTORY.RESERVE;

    const [selected, setSelected] = useState({});
    const [edit, setEdit] = useState();
    const [picked, setPicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState({ rows: [], total: 0 });
    const [align, setAlign] = useState("auto");
    const buffer = 4;
    const limit = 10;
    const row_key = "order_id";
    const refs = useRef([]);

    const customerRequired = (tab === "reserve");

    const deleteOrder = () => {

        if (!selected?.order_id) {
            showError({ error: "Order doesn't exist." })
            return;
        }

        const el = refs.current?.[selected?.[row_key]];
        if (el) {
            if (typeof el.blur === "function") {
                el.blur();
            }
        }

        showConfirm({
            controller: controller,
            route: route,
            description: <div style={{ "textAlign": "center" }}>Delete this order?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {

                    setLoading(true)
                    pubCall("order.removeItem", { require_clerk_code: true, order_id: selected?.order_id }, (_s, _r) => {
                        if (_s) {
                            showMessage("Order removed.");
                            getOrders()
                        } else {
                            showError(_r);
                        }
                        setLoading(false);
                        if (el) {
                            if (typeof el.focus === "function") {
                                el.focus();
                            }
                        }

                    })
                } else {
                    if (el) {
                        if (typeof el.focus === "function") {
                            el.focus();
                        }
                    }
                }
            }
        })
    }

    const editOrder = () => {
        props?.setState({
            ...props.state, pubstock: "full", view: "order", order: {
                quantity: selected?.quantity,
                order: selected,
                reserveFromOrder: false,
            }
        })
        window.bm_state.value = ROUTES.INVENTORY.ORDER;
    }

    const reserve_nav = [
        { text: "Delete", key: KBD.D, action: (e) => { deleteOrder() } },
        { text: "Edit", key: KBD.E, action: () => { editOrder() } },
        { text: "Print" },
        { text: "Reserve" },
        { text: "View" },
        { text: "Track" },
    ]

    useEffect(() => {
        setTimeout(() => {
            window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        }, 10)
    }, [])

    useEffect(() => {
        const actions = [
            {
                key: KBD.Digit1, action: (e) => {

                    if (selected?.status === "Pend") {
                        processItem(1, { ...selected })
                    }

                }
            },
            { key: KBD.ARROW_DOWN, action: (e) => { next(); } },
            { key: KBD.ARROW_UP, action: (e) => { prev(); } },
            { key: KBD.COMMA, action: (e) => { togglePubstock() } },
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },

        ];
        const cleanup = listen(controller, route, actions.concat(reserve_nav), false, [KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.COMMA, KBD.PAGE_DOWN, KBD.D, KBD.E, KBD.Digit1]);
        return cleanup;
    }, [selected, state]);

    const getOrders = (_offset = 0) => {
        window.bm_state.value = route;
        setLoading(true)
        pubCall("order.getPendingOrRecentItem", { primary_code: primary_code, condition_code: condition_code, limit: limit, offset: _offset }, (_s, _r) => {
            if (_s) {

                if (_offset) {
                    setResults({ ...results, "rows": results.rows.concat(_r.rows) });
                } else {
                    setResults(_r);
                    if (_r?.rows.length > 0) {


                        let selected;
                        const pending = _r.rows.filter(item => !item?.customer && item.status_date && item.status === "Pend") || [];

                        const oldest_pending = (pending.length) ? pending.reduce((oldest, curr) => {
                            const a = oldest.status_date || 0;
                            const b = curr.status_date || 0;
                            return b <= a ? curr : oldest;
                        }) : [];


                        // Guessing status_date? 
                        const sent = _r.rows.filter(item => !item?.customer && (item.status?.startsWith("O") || item.status === "Ship")) || [];
                        const oldest_sent = (sent.length) ? sent.reduce((oldest, curr) => {
                            const a = oldest.status_date || 0;
                            const b = curr.status_date || 0;
                            return b <= a ? curr : oldest;
                        }) : [];


                        if (tab === "orders") {

                            if (pending.length) {
                                selected = oldest_pending;
                            } else {
                                // pick first
                                selected = _r.rows[0];
                            }
                            setSelected(selected);
                        } else {
                            if (sent.length) {
                                selected = oldest_sent;
                            } else if (pending.length) {
                                selected = oldest_pending;
                            } else {
                                // pick first
                                selected = _r.rows[0];
                            }
                            setSelected(selected);
                        }
                    }
                }
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }
    useEffect(getOrders, []);



    const drawOrder = (_quantity, _order, _reserveFromOrder = false) => {


        setEdit({
            quantity: _quantity,
            order: _order,
            reserveFromOrder: _reserveFromOrder,
        })

        props?.setState({
            ...props.state, pubstock: "full", view: "order", order: {
                quantity: _quantity,
                order: _order,
                reserveFromOrder: _reserveFromOrder,
            }
        })

        window.bm_state.value = ROUTES.INVENTORY.ORDER;

        return;

    }




    const processItem = (e, f, _new = true) => {

        if (isNaN(e)) {
            return;
        }
        if (e === "0") {
            deleteOrder();

            return;
        }

        if (!parseInt(e)) {
            e = 1;
        }
        if (!_new && customerRequired && e > f.quantity) {
            e = f.quantity;
        }
        if (_new) {
            drawOrder(e, f, customerRequired);
        } else {
            drawOrder(e, f, customerRequired);
        }




    }

    const isActive = (_status = "") => {


        if (tab === "reserve") {
            return (_status.startsWith("O") || _status === "Ship" || _status === "Pend" && _status !== "Odth")
        } else {
            return (_status === "Pend");
        }

    }

    const proceedToQty = (e, f, evt = false) => {

        if (evt) {
            evt.preventDefault();
            evt.stopPropagation()
        }
        if (f?.status !== "Pend") {
            showError({ "error": "You can't do that" })
            return;
        }
        processItem(e, f, false);
    }

    const columns = [
        {
            title: <>Qty</>, key: "quantity", width: 30, grow: false, render: (e, f) => {
                if (selected?.[row_key] === f?.[row_key] && (f?.[row_key] === results?.rows?.[0]?.[row_key])) {
                    return (
                        <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px" }}>
                            <NumberPicker offset={[-15, -20]} active={isActive(f?.status)} onSelect={(e) => { processItem(e, f); }}>
                                <Input onEnter={(e) => { processItem(e, f); }} onChange={(e) => { processItem(e, f); }} onPageDown={(e, evt) => {
                                    evt.preventDefault();
                                    evt.stopPropagation()
                                    processItem(e, f);
                                }} value={e} ref={(e) => (refs.current[f?.[row_key]] = e)} right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} cell edit={f?.status === "Pend"} />
                            </NumberPicker>
                        </div>
                    )
                } else {
                    if (selected?.[row_key] === f?.[row_key] && isActive(f?.status)) {

                    
                        return (
                            <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px", "opacity": "1" }}>
                                <NumberPicker onDelete={() => processItem("0", f)} showDelete offset={[-15, -20]} active={true} onSelect={(e) => { processItem(e, f); }}>
                                    <Input onEnter={(e) => { proceedToQty(e, f) }} onChange={(e) => { proceedToQty(e, f) }} onPageDown={(e, evt) => { proceedToQty(e, f, evt) }} value={(isActive(f?.status)) ? e : ""} ref={(e) => (refs.current[f?.[row_key]] = e)} right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} cell edit={isActive(f?.status)} />
                                </NumberPicker>
                            </div>
                        )
                    }
                    return "";
                }
            }
        },
        {
            title: <>OnOrder</>, key: "onorder", width: 65, grow: false, align: "right", render: (e, f) => {

                if (!f?.order_id) {
                    return "";
                }

                return f.quantity || "";
            }
        },
        {
            title: <>Supl</>, key: "supplier", width: 60, grow: false, align: "left", render: (e, f) => {
                if (f.order_id === "") {
                    return (<em>{e}</em>)
                } else {
                    return e;
                }
            }
        },
        { title: <>Grp</>, key: "order_separator", width: 33, grow: false, align: "left" },
        { title: <>Order#</>, key: "order_number", width: 80, grow: false, align: "left" },
        { title: <>Date</>, key: "status_date", width: 100, grow: false, align: "left", render: (e) => (e) ? bm_date(e) : "" },
        {
            title: <>Status</>, key: "status", width: 65, align: "left", grow: false, render: (e, f) => {
                if (f.order_id === "") {
                    return (<em>{e}</em>)
                } else {
                    return e;
                }

            }
        },
        {
            title: <>Notes</>, key: "note", width: 60, align: "left", grow: true, render: (e, f) => {
                if (f.order_id === "") {
                    return (<em>New Order</em>)
                } else {
                    return e;
                }
            }
        },
        {
            title: <>Customer</>, key: "customer", width: 60, align: "left", grow: true, render: (c) => {
                return c?.name || ""
            }
        },
        { title: <>T</>, key: "is_single_title_order", width: 20, align: "center", grow: false },
        { title: <>CustPO</>, key: "customer_po", width: 125, align: "left", grow: false },
        { title: <>Cl</>, key: "clerk_code", width: 30, align: "left", grow: false },
    ]


    useEffect(() => {
        if (selected.hasOwnProperty([row_key]) && refs?.current?.[selected?.[row_key]]) {
            refs.current[selected?.[row_key]].focus();
            refs.current[selected?.[row_key]].select()
        }
    }, [selected])

    const next = (_inc = 1) => {
        const ci = results?.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        if (ci > -1) {
            if (ci + _inc > results.rows.length - _inc) {
                setSelected(results.rows[results.rows.length - 1]);
            } else {
                setSelected(results.rows[ci + 1]);
            }
        }
    }

    const prev = (_inc = 1) => {
        const ci = results?.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        if (ci > -1) {
            if (ci - _inc > -1) {
                setSelected(results.rows[ci - 1]);
            } else {
                setSelected(results.rows[0])
            }
        }
    }

    useEffect(() => {
        if (!results || !selected) return;
        const ci = results.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        const nearEnd = ci > -1 && (results.rows.length - ci <= buffer);
        const canLoadMore = results.rows.length < results.total;
        if (nearEnd && canLoadMore) {
            const nextOffset = results.rows.length;
            getOrders(nextOffset);
        }
    }, [selected, results]);



    return (
        <div>
            <VirtualTable

                header={<div><Space><Label style={{ "color": "var(--text)" }}>Order for Stock or Customer:</Label><small style={{ "color": "var(--text-yellow)" }}>{fullData?.stock?.title} <em><small>({getBindingLabel(fullData?.stock?.binding)})</small></em></small></Space></div>}
                controller={controller}
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                rowClass={(e) => {
                    const _cls = getRowClass(e);
                    if (!e?.order_id || !(e?.status.startsWith("R") || e?.status.startsWith("C"))) {
                        return _cls + " history-active"
                    }
                    return _cls;
                }}
                align={align}
                row_key={row_key}
                current={selected}
                data={results?.rows || []}
                columns={columns}
                width={962}
                height={220}
                loading={loading}
                offset={430}
                route={route}
            />
            <div className="shim" /><div className="shim" />
            <div style={{ "position": "relative", "top": "0px" }}>
                <div style={{ "padding": "0px 0px" }}><Nav nav={reserve_nav} />

                </div>


            </div>
        </div>
    )
}